export default {
  data() {
    return {
      reservationStatusRefundConst: [
        {label: this.$t('reservation.statusRefund_pending'), value: 'PENDING'},
        {label: this.$t('reservation.statusRefund_accepted'), value: 'ACCEPTED'},
        {label: this.$t('reservation.statusRefund_refused'), value: 'REFUSED'},
        {label: this.$t('reservation.statusRefund_contested'), value: 'CONTESTED'},
      ],
    };
  },
  methods: {
    displayForReservationStatusRefundConst(value) {
      let result = this.reservationStatusRefundConst.find((el) => el.value === value);
      return result ? result.label : '';
    },
  },
};
